import React from "react";
import { Select } from "antd";
import SidebarContents from "./SidebarContents";
import SectionContents from "./SectionContents";

const ContentsContainer = ({
  sections,
}) => {
  return (
    <div className="flex flex-col lg:flex-row">

      <div className="hidden lg:block">
        <SidebarContents sections={sections} />
      </div>

      <div className="flex-1 p-4 lg:p-6 space-y-6 max-w-4xl">

        <Select
            className="lg:hidden w-full input-field"
            placeholder="Jump to section"
            onChange={(value) => {
            const el = document.getElementById(value);
            if (!el) return;

            const yOffset = -140;

            const y =
                el.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;

            window.scrollTo({
                top: y,
                behavior: "smooth",
            });
            }}
        >
            {sections.map((section) => (
            <Select.Option
                key={section.sectionId}
                value={section.sectionId}
            >
                {section.sectionTitle}
            </Select.Option>
            ))}
        </Select>

        {sections.map((section) => (
          <SectionContents
            key={section.sectionId}
            sectionId={section.sectionId}
            sectionTitle={section.sectionTitle}
            sectionBody={section.sectionBody}
          />
        ))}
      </div>
    </div>
  );
};

export default ContentsContainer;